import * as React from 'react'
import * as TooltipPrimitive from '@radix-ui/react-tooltip'
import { cn } from '@shared/lib'

/**
 * Tooltip provider that wraps the application for tooltip context.
 * Use once at app root level.
 */
const TooltipProvider = TooltipPrimitive.Provider

/**
 * Tooltip root component.
 */
const Tooltip = TooltipPrimitive.Root

/**
 * Tooltip trigger that activates the tooltip on hover/focus.
 */
const TooltipTrigger = TooltipPrimitive.Trigger

/**
 * Tooltip content with styled portal rendering.
 */
const TooltipContent = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
>(({ className, sideOffset = 4, ...props }, ref) => (
  <TooltipPrimitive.Portal>
    <TooltipPrimitive.Content
      ref={ref}
      sideOffset={sideOffset}
      className={cn(
        // z-[120] sits above dialogs/sheets (z-[110]) so tooltips inside a modal aren't clipped behind it.
        'bg-popover text-popover-foreground animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-[120] overflow-hidden rounded-md border px-3 py-1.5 text-sm shadow-md',
        className
      )}
      {...props}
    />
  </TooltipPrimitive.Portal>
))
TooltipContent.displayName = TooltipPrimitive.Content.displayName

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider }
